/**
 * Formateo locale es-GT, consistente con el móvil.
 * Usamos 'en-US' (no 'es-GT') porque ese locale produce comas+puntos
 * confiables en cualquier navegador. 'es-GT' depende del ICU del sistema y
 * en algunos navegadores móviles sale sin separador de miles. Eso fue lo
 * que llevó a Hugo a reportar varias veces "los formatos de números no
 * tienen la coma".
 */

const FMT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** "10,000.00" — sólo el número, sin Q. */
export function formatNumero(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '0.00'
  const n = typeof v === 'number' ? v : Number(v)
  if (!Number.isFinite(n)) return '0.00'
  return FMT.format(n)
}

export function formatQ(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return 'Q 0.00'
  const n = typeof amount === 'number' ? amount : Number(amount)
  if (!Number.isFinite(n)) return 'Q 0.00'
  const sign = n < 0 ? '-' : ''
  return `${sign}Q ${FMT.format(Math.abs(n))}`
}

/** "+ Q 10,000.00" / "− Q 10,000.00" — para ingresos/egresos firmados. */
export function formatQSigned(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '+ Q 0.00'
  const n = typeof v === 'number' ? v : Number(v)
  if (!Number.isFinite(n)) return '+ Q 0.00'
  const signo = n < 0 ? '−' : '+'
  return `${signo} Q ${FMT.format(Math.abs(n))}`
}

/** Limpia un string libre y devuelve el número (sin formato). */
export function parseMontoInput(raw: string): number {
  const clean = raw.replace(/[^\d.]/g, '')
  return clean ? Number(clean) : 0
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    const d = new Date(iso)
    return d.toLocaleString('es-GT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Guatemala',
    })
  } catch {
    return iso
  }
}

export function formatRelative(iso: string): string {
  const now = Date.now()
  const then = new Date(iso).getTime()
  const diffS = Math.round((now - then) / 1000)
  if (diffS < 60) return 'hace un momento'
  if (diffS < 3600) return `hace ${Math.round(diffS / 60)} min`
  if (diffS < 86400) return `hace ${Math.round(diffS / 3600)} h`
  if (diffS < 7 * 86400) return `hace ${Math.round(diffS / 86400)} d`
  return formatDateTime(iso)
}

export const PERIODO_LABEL: Record<string, string> = {
  month: 'Mes actual',
  '3months': 'Últimos 3 meses',
  year: 'Año corriente',
}

export const ESTADO_LABEL: Record<string, string> = {
  pendiente: 'Pendiente',
  en_proceso: 'En proceso',
  enviado: 'Enviado',
  cancelado: 'Cancelado',
}

export const CANAL_LABEL: Record<string, string> = {
  email: 'Email',
  whatsapp: 'WhatsApp',
}
